import React from "react";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import {Config} from "../Config";
import * as Utils from "../inc/Utils";
import {Link} from "react-router-dom";

export default function Internal(prop) {

    let [internal, setInternal] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const internalListing = await getInternal();
                setInternal(internalListing);
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getInternal() {
        const response = await fetch(Config.apiUrl +'internalCategory/listWithInternal', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / {prop.lang === 'en' ? 'Partners':'หน่วยงานเครือข่าย'}</p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Partners':'หน่วยงานเครือข่าย'}</span>
                    </h1>
                </div>
            </div>


            <div className="section bg-light">
                <div className="container text-center">
                    {
                        internal !== null && internal.count > 0 ?
                            <>
                                {
                                    internal.rows.map((rs, index) => {
                                        return (
                                            <div className="mb-3">
                                                <h3 className="py-4">{Utils.cleanOutput(prop.lang === 'en' ? rs.title_en:rs.title)}</h3>
                                                {
                                                    rs.internalData.length > 0 ?
                                                        <div className="row card-pathner-list">
                                                            {
                                                                rs.internalData.map((row, index) => {
                                                                    return (
                                                                        <div className="col-xl-3">
                                                                            <div className="card-pathner">
                                                                                <div className="card-photo">
                                                                                    {
                                                                                        row.link !== null ? <Link to={row.link} target="_blank" title={prop.lang === 'en' ? row.title_en:row.title}><img src={Config.fileUpload + 'internal/' + row.image} alt={Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)} /></Link> : <img src={Config.fileUpload + 'internal/' + row.image} alt={Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)} />
                                                                                    }
                                                                                </div>
                                                                                <h3>{Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)}</h3>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div> : ''
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </> : ''
                    }
                </div>
            </div>
        </>
    );
} 